import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { LoanScheduleDetailsObj } from "../../utils/types";

const initialState: LoanScheduleDetailsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getLoanScheduleData = createAsyncThunk(
  "loans/getLoanScheduleDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);

      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const loanScheduleDetailsSlice = createSlice({
  name: "loanSchedule",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoanScheduleData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLoanScheduleData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getLoanScheduleData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default loanScheduleDetailsSlice.reducer;
